module.exports = __webpack_public_path__ + "src/images/products/active/19_Tri-Block Ankle Sock.png";